import OVARY from './cancerCerts/_dkg_brust-eierstockkrebs_rgb.svg'
import CHEST from './cancerCerts/_dkg_brust_rgb.svg'
import CHEST_NRW from './cancerCerts/_dkg_brust_nrw.svg'
import BOWEL from './cancerCerts/_dkg_darm_rgb.svg'
import DYSPLASIA from './cancerCerts/_dkg_gyn-dys-einheit_rgb.svg'
import DYSPLASIA_CONSULTATION from './cancerCerts/_dkg_gyn-dys-sprechstd_rgb.svg'
import GYNECOLOGY from './cancerCerts/_dkg_gyn_rgb.svg'
import URINARY_BLADDER from './cancerCerts/_dkg_harnblasenkrebs_rgb.svg'
import SKIN from './cancerCerts/_dkg_haut_rgb.svg'
import CHILD_ONCOLOGY from './cancerCerts/_dkg_kinderonko_rgb.svg'
import HEAD_NECK from './cancerCerts/_dkg_kopf-hals_rgb.svg'
import LIVER from './cancerCerts/_dkg_leber_rgb.svg'
import LUNG from './cancerCerts/_dkg_lunge_rgb.svg'
import STOMACH from './cancerCerts/_dkg_magen_rgb.svg'
import NEOPLASIA from './cancerCerts/_dkg_neoplasien_rgb.svg'
import NEUROONCOLOGY from './cancerCerts/_dkg_neuroonko_rgb.svg'
import RENAL from './cancerCerts/_dkg_nierenkrebs_rgb.svg'
import ONCOLOGY from './cancerCerts/_dkg_onko_rgb.svg'
import PANCREAS from './cancerCerts/_dkg_pankreas_rgb.svg'
import PROSTATE from './cancerCerts/_dkg_prostata_rgb.svg'
import SARCOMA from './cancerCerts/_dkg_sarkomzentrum_rgb.svg'
import GULLET from './cancerCerts/_dkg_speiseroehre_rgb.svg'

import CAREHOME_PLUS from './insuredOffers/koop-pflegeheimplus.gif'
import CARENETWORK from './insuredOffers/koop-pflegenetz.jpg'
import FALLING_PREV from './insuredOffers/koop-sturzpraevention.gif'
import TEAMWERK from './insuredOffers/koop-teamwerk.jpg'

import QUATRO_SEAL_GREEN_2021 from './quatroSeals/QuATRo_Siegel_2021_Gruen.svg'
import QUATRO_SEAL_SILVER_2021 from './quatroSeals/QuATRo_Siegel_2021_Silver.svg'
import QUATRO_SEAL_GOLD_2021 from './quatroSeals/QuATRo_Siegel_2021_Gold.svg'
import QUATRO_SEAL_GREEN_2022 from './quatroSeals/QuATRo_Siegel_2022_Gruen.svg'
import QUATRO_SEAL_SILVER_2022 from './quatroSeals/QuATRo_Siegel_2022_Silver.svg'
import QUATRO_SEAL_GOLD_2022 from './quatroSeals/QuATRo_Siegel_2022_Gold.svg'
import QUATRO_SEAL_GREEN_2023 from './quatroSeals/QuATRo_Siegel_2023_Gruen.svg'
import QUATRO_SEAL_SILVER_2023 from './quatroSeals/QuATRo_Siegel_2023_Silber.svg'
import QUATRO_SEAL_GOLD_2023 from './quatroSeals/QuATRo_Siegel_2023_Gold.svg'

import PIP_SEAL from './workplaceHealthPromotion/PiP_Siegel_RZ.svg'

export const certs = {
  OVARY,
  CHEST,
  CHEST_NRW,
  BOWEL,
  DYSPLASIA,
  DYSPLASIA_CONSULTATION,
  GYNECOLOGY,
  URINARY_BLADDER,
  SKIN,
  CHILD_ONCOLOGY,
  HEAD_NECK,
  LIVER,
  LUNG,
  STOMACH,
  NEOPLASIA,
  NEUROONCOLOGY,
  RENAL,
  ONCOLOGY,
  PANCREAS,
  PROSTATE,
  GULLET,
  SARCOMA,
}

export const insuredOffers = {
  CAREHOME_PLUS,
  CARENETWORK,
  FALLING_PREV,
  TEAMWERK,
}

export const quatroSeals = {
  2021: {
    'quatro-green': QUATRO_SEAL_GREEN_2021,
    'quatro-silver': QUATRO_SEAL_SILVER_2021,
    'quatro-gold': QUATRO_SEAL_GOLD_2021,
  },
  2022: {
    'quatro-green': QUATRO_SEAL_GREEN_2022,
    'quatro-silver': QUATRO_SEAL_SILVER_2022,
    'quatro-gold': QUATRO_SEAL_GOLD_2022,
  },
  2023: {
    'quatro-green': QUATRO_SEAL_GREEN_2023,
    'quatro-silver': QUATRO_SEAL_SILVER_2023,
    'quatro-gold': QUATRO_SEAL_GOLD_2023,
  },
}

export const workplaceHealthPromotion = {
  PIP_SEAL,
}
